import { http } from '@/services/http';

export type StatsRange = 'WeeksInMonth' | 'Month' | 'Quarter' | 'Year';
export type ChartType = 'oar' | 'users';

export interface StatsPoint {
  year: number;
  period: number;
  orders?: number;
  reservations?: number;
  numberOfUsersCreated?: number;
}

export interface StatsListItem {
  name: string;
  email: string;
  emsl_user_id?: string;
  created_at?: string;
}

export const userStatsApi = {
  get(range: StatsRange, chartType: ChartType): Promise<StatsPoint[]> {
    return http<StatsPoint[]>({
      url: `user_stats/${range}/${chartType}`,
      method: 'get',
    });
  },
  getList(
    period: StatsRange,
    partOfPeriod: number | string,
    chartType: ChartType,
  ): Promise<StatsListItem[]> {
    return http<StatsListItem[]>({
      url: `user_stats/${period}/${partOfPeriod}/${chartType}`,
      method: 'get',
    });
  },
};
